@if(breakpointService.isDesktop()) {
  <div class="audio-tours-container">
    <div class="audio-tours-container__swiper-box" appSwiper [swiperOptions]="swiperOptions">
      <div class="swiper-wrapper">
        @if (!isFetching) {
          @for (tour of tours; track tour.title) {
            <div class="swiper-slide">
              <app-voice-guide-card-mobile
                [tour]="tour"
                [countryName]="countryName"
                [cityName]="cityName"
              ></app-voice-guide-card-mobile>
            </div>
          }
        } @else {
          @for (tour of fetchingTours; track $index) {
            <div class="swiper-slide">
              <div class="tour-fetching" #tourCard>
                <ngx-skeleton-loader [theme]="{height: tourCard.clientHeight + 'px', margin: 0}"></ngx-skeleton-loader>
              </div>
            </div>
          }
        }
      </div>

      <div class="swiper-button-prev with-background"></div>
      <div class="swiper-button-next with-background"></div>
    </div>
  </div>
} @else {
  <app-voice-guide-list-mobile
    [isFetching]="isFetching"
    [cityName]="cityName"
    [countryName]="countryName"
    [tours]="tours"
  ></app-voice-guide-list-mobile>
}
